export default "__VITE_ASSET__D7Go5Qap__"